import React from 'react'
import _ from 'lodash'
import ReactModal from 'react-modal'
import NavigationBar from '../Commons/NavigationBar'
import moment from 'moment'
import calculate from './MedicalCalculate'
import * as request from 'superagent'
import { getToken } from '../Commons/Authentication'
import DashboardBasicData from './DashboardBasicData'
import { hashHistory } from 'react-router'
import PatientData from '../../img/icons/general-icons/icon_data.png'
import DashboardSpecialCondition from './DashboardSpecialCondition'
import DashboardMedicalData from './DashboardMedicalData'
import DashboardRiskFactors from './DashboardRiskFactors'
import DashboardSeveritySection from './DashboardSeveritySection'
import DashboardChartComponent from './DashboardChartComponent'
import DashboardHealthSquaresComponent from './DashboardHealthSquaresComponent'

import { ToastContainer, ToastMessage } from 'react-toastr'
import closeModal from '../../img/icons/general-icons/close.png'
import {Typeahead} from 'react-bootstrap-typeahead'
const ToastMessageFactory = React.createFactory(ToastMessage.animation)
export default class PatientDashboard extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({
      codigo_cie_10:'',
      date_muerte: '',
      muerto: false,
      data: {
        showModalEdit:false,
        patientImage: '',
        patientData: {},
        patientFullName: '',
        patientnumeroDocumento: '',
        patientIdentification: '',
        patientAge: '',
        patientGender: '',
        patientBirthDay: '',
        medicalData: {},
        medicalPAParado: '',
        medicalPASentado: '',
        medicalFrecuenciaC: '',
        medicalBalanceNeur: '',
        medicalPeso: '',
        medicalBMIData: '',
        medicalColTotal: '',
        medicalColLDL: '',
        medicalColHDL: '',
        medicalColTrigliceridos: '',
        medicalCreatinina: '',
        medicalCol: '',
        chart1: [0, 0, 0, 0, 0],
        chart2: [0, 0, 0, 0, 0],
        percent_lost_capacity: 0,
        fx_reserve: 0,
        arterialAge: 0,
        biologicalAge: 0
      },
      print: true
    })
  }

  componentWillMount () {
    this.findPatientDashboard()
    this.findCie10()
  }

  findPatientDashboard () {
    let identificacion = this.props.params.patient
    request
      .get('api/v1/patient/find?numeroDocumento=' + identificacion)
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err, 'And respo: ', res)
        } else {
          let result = res.body[0]

          var birthday = new Date(result.fechaNacimiento.split('/').reverse().join('-'))
          var ageDifMs = Date.now() - birthday.getTime()
          var ageDate = new Date(ageDifMs)
          var age = Math.abs(ageDate.getUTCFullYear() - 1970)

          // console.log( moment(result.date_muerte).format('DD/MM/YYYY'), 'formated')

          var newData = this.state.data
          newData.patientImage = result.image
          newData.patientGender = result.genero
          newData.patientBirthDay = moment(result.fechaNacimiento).format('DD/MM/YYYY')
          newData.patientFullName = result.nombres + ' ' + result.apellidos
          newData.numeroDocumento = result.numeroDocumento
          newData.patientIdentification = result.tipoDocumento + ' ' + newData.numeroDocumento
          newData.patientAge = age
          newData.patientData = result
          let date_muerte = String(moment(result.date_muerte).format('YYYY-MM-DD'))
          let muerto = result.muerto
          let descripcion = ''
          newData.muerto = muerto
          newData.date_muerte = date_muerte

          try{
            descripcion = result.codigo_cie_muerte ? [`(${result.codigo_cie_muerte}) ${result.descripcion_codigo_cie}`] : ''
          } catch(e){
            console.log(e, 'error en descripcion 102')
          }
          this.setState({
            date_muerte: date_muerte,
            muerto: result.muerto,
            'codigo_cie_10': descripcion,
            'codigo_cie': result.codigo_cie_muerte,
            'descripcion': result.descripcion_codigo_cie,
            data: newData
          })
        }
        this.findMedicalPatient()
      })
  }
  deathController (e) {
    e.preventDefault()

    this.setState({showModalEdit:true})
  }
  handleInputChange (event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    // letcodigo_cie_10 = value ? this.state.codigo_cie_10: ''
    this.setState({
      [name]: value
    })
  }
  medicalDataCapture (e) {
    e.preventDefault()
    let age = this.state.data.patientAge
    let url = 'medical/' + this.props.params.patient
    console.log(age)
    if (age < 21 || age > 80) {
      this.refs.container.warning('Paciente con un rango de edad donde los cálculos no son exactos', '', {
        closeButton: true
      })
      setTimeout(() => { hashHistory.push(url) }, 3600)
    } else {
      hashHistory.push(url)
    }
  }
  closeModal (e) {
    e.preventDefault()
    this.setState({showModalEdit: false})
  }
  findMedicalPatient () {
    let identificacion = this.props.params.patient
    request
      .get('api/v1/medical/findMedicalById')
      .query({ id: identificacion, limit: 50, sort: 1 })
      .set('Authorization', 'Bearer ' + getToken())
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || !res.ok) {
          console.log('Error: ', err)
        } else {
          
          let size = res.body.length
          let medicalInfo = res.body[size-1]
          let altura = medicalInfo.altura / 100
          let peso = medicalInfo.peso
          let indiceMasaC = Math.floor(peso / (altura * altura))
          // Debugg el estado para ver que nos llega desde el backend
          // TODO: limpiar este desastre para otro archivo de acciones con el backend o movelo a redux
          var newData = this.state.data
          newData.allobj = res.body
          newData.medicalData = medicalInfo
          newData.medicalPAParado = medicalInfo.presionParadoAlta + ' / ' + medicalInfo.presionParadoBaja
          newData.medicalPASentado = medicalInfo.presionSentadoAlta + ' / ' + medicalInfo.presionSentadoBaja
          newData.medicalFrecuenciaC = medicalInfo.frecuencia
          newData.medicalBalanceNeur = medicalInfo.balanceNeuroMuscularT
          newData.medicalPeso = medicalInfo.peso
          newData.medicalBMIData = indiceMasaC
          newData.medicalColTotal = medicalInfo.colesterolTotal + ' mg/dL'
          newData.medicalColLDL = medicalInfo.colesterolLDL + ' mg/dL'
          newData.medicalColHDL = medicalInfo.colesterolHDL + ' mg/dL'
          newData.medicalColTrigliceridos = medicalInfo.trigliceridos + ' mg/dL'
          newData.medicalCreatinina = medicalInfo.creatinina + ' mg/dL'
          newData.medicalColGlicemia = medicalInfo.glicemia + ' mg/dL'

          this.setState({
            data: newData
          })
        }
        this.medicalCalculate()
      })
  }
  onChangeCie10(event){
    let cloneEvent = event
    let cie_descripcion = ''
    let codigo_cie = ''
    let descripcion = ''
    if(event != '' && event) {
      cie_descripcion = cloneEvent[0].split(') ')
      codigo_cie = cie_descripcion[0].replace('(','')
      descripcion = cie_descripcion[1]
    }

    this.setState({'codigo_cie_10': event, codigo_cie: codigo_cie, descripcion: descripcion})
  }
  findCie10 (event) {
    let endpoint = '/api/v1/pathology/'
    request
    .get(endpoint)
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .end((err, res) => {
      if(res.body){
        let arr = res.body.map((e) => { return `(${e.codigo_cie}) ${e.descripcion}`})
        this.setState({arr: arr})
      }
    })
  }
  handleCloseModal () {
    this.setState({showModalEditConfirm: false,showModalEdit:false})
  }
  hangleChangeDate () {
    console.log(typeof this.refs.date_muerte.value)
    this.setState({date_muerte:  this.refs.date_muerte.value})
  }
  handleSaveConfirm () {
    this.setState({showModalEditConfirm: false})
    let newData = this.state

    let updatePatient = {id: this.state.data.patientData.id,muerto: this.state.muerto,codigo_cie_muerte: this.state.codigo_cie, descripcion_codigo_cie: this.state.descripcion, date_muerte: this.state.date_muerte }
    let endpoint = '/api/v1/patient/'
    request
    .put(endpoint)
    .set('Authorization', 'Bearer ' + getToken())
    .set('Accept', 'application/json')
    .send(updatePatient)
    .end((err, res) => {
      if(res){
        let data = {}
        this.setState({showModalEdit: false})
      }
    })
  }
  saveStatePatient () {
    this.setState({showModalEditConfirm:true })
  }
  handleChangeDatepiker () {
  }
  medicalCalculate () {
    let healthRate = this.state.data.medicalData.frecuencia
    let timeFiveMe = this.state.data.medicalData.tiempoCincoM
    // let balanceNeu = this.state.data.medicalData.balanceNeuroMuscularT
    let ArrayBalance =  [this.state.data.medicalData.balanceNeuroMuscular, this.state.data.medicalData.balanceNeuroMuscularD]
    let balanceNeu = ArrayBalance.reduce((max, val) =>{ return Math.max(max,val)},ArrayBalance[0])
    balanceNeu = (balanceNeu < 10) ? 10 : (balanceNeu > 42) ? 42 : balanceNeu
    let cardioResp = this.state.data.medicalData.mets
    let transcendence = this.state.data.medicalData.depresion
    let satisfaccion = this.state.data.medicalData.satisfaccion
    let felicidad = this.state.data.medicalData.feliz
    let preocupado = this.state.data.medicalData.preocupacion
    let depresion = this.state.data.medicalData.decaido
    let gender = this.state.data.patientData.genero
    let peso = this.state.data.medicalData.peso
    let altura = this.state.data.medicalData.altura
    let birthday = moment(this.state.data.patientData.fechaNacimiento).format('DD/MM/YYYY')
    let smoke = this.state.data.medicalData.fuma
    let movility = this.state.data.medicalData.movilidad
    let personalCare = this.state.data.medicalData.cuidadoPersonal
    let dActivities = this.state.data.medicalData.actividadesCotidianas
    let patientPain = this.state.data.medicalData.dolor
    let anxiety = this.state.data.medicalData.ansiedad
    let calculos = calculate(healthRate, timeFiveMe, balanceNeu, cardioResp, transcendence, satisfaccion, felicidad, preocupado, depresion,
      gender, peso, altura, birthday, smoke, movility, personalCare, dActivities, patientPain, anxiety)

    var newData = this.state.data
    newData.chart1 = calculos[0]
    newData.chart2 = calculos[1]
    newData.percent_lost_capacity = calculos[4]
    newData.fx_reserve = calculos[5]
    newData.arterialAge = calculos[6]
    newData.biologicalAge = calculos[7]

    this.setState({
      data: newData
    })
  }

  render () {
    document.title = 'Dashboard - CORE 3.0'
    var myData = [
      'John',
      'Miles',
      'Charles',
      'Herbie',
    ]
    if(this.state.arr){
      myData = this.state.arr
    }
    return (
      <div className='dashboard-container'>
      <ReactModal
      className='edit-patient'
      isOpen={this.state.showModalEdit}
      contentLabel="Editar Estado del paciente."
      overlayClassName="Overlay"
      >
      <div className="header-modal-section-close">
          <img className="closeModalIcon" src={closeModal} onClick={this.closeModal.bind(this)}/>
      </div>
        <div className='container-modal'>
          <div className='checkbox'>
            <span>Fallecido </span>
            <input  name="muerto"
            type="checkbox"
            checked={this.state.muerto}
            onChange={this.handleInputChange.bind(this)}/>
            </div>
            <div className='col-span'>
              Código Cie 10.
              <br/>
              <Typeahead className='typeahead-boostrap' options={myData} onChange={this.onChangeCie10.bind(this)} placeholder="Elige un código cie 10" selected={this.state.codigo_cie_10}/>
            </div>
            <div className='col-span'>
              Fecha.
              <br/>
              <input className='date_muerte' ref='date_muerte' value={this.state.date_muerte} type='date' onChange={this.hangleChangeDate.bind(this)}/>
            </div>
            <div className='save-button-'>
            {this.state.codigo_cie_10 && this.state.date_muerte ?
              <div className='save-modal' onClick={this.saveStatePatient.bind(this)}>Guardar</div>
              : ''}
            </div>
            <ReactModal
            className='alert-modal'
            isOpen={this.state.showModalEditConfirm}
            contentLabel="Editar Estado del paciente."
            overlayClassName="Overlay"
            >
                <p className='pAlert'>
                Deseas confirmar el cambio de estado del paciente. Al seleccionar fallecido la información deja de ser editable y deshabilita todas las funciones. Si se quita el rotulo de fallecido se activara nuevamente las funciones.
                </p>
              <div className='buttonAction' onClick={this.handleCloseModal.bind(this)}>Cancelar</div>
              <div className='buttonAction' onClick={this.handleSaveConfirm.bind(this)}>Continuar</div>
            </ReactModal>
          </div>
      </ReactModal>
        <NavigationBar print={this.state.print}/>
        <div className='patient-information-container'>
          <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
          <DashboardBasicData data={this.state.data} state={this.state}/>
          {this.props.params.patient&&
          <DashboardSpecialCondition data={this.state.data} identification={this.props.params.patient} />}
          <div className='medical-link header-medical-data' onClick={this.deathController.bind(this)}>
            <img className='data-image' src={PatientData}/>
            <label className='text-link'>Editar estado del paciente</label>
          </div>
          <div className='medical-link header-medical-data' onClick={this.medicalDataCapture.bind(this)}>
            <img className='data-image' src={PatientData}/>
            <label className='text-link'>Tomar datos</label>
          </div>
          <DashboardMedicalData data={this.state.data} />
          <DashboardRiskFactors data={this.state.data} />
        </div>
        <div className='dashboard-charts-components'>
          <div className='status-graphics-container'>
            <div className='charts-square-container'>
              <DashboardSeveritySection data={this.state.data} />
              <DashboardChartComponent data={this.state.data} patient={this.props.params.patient}/>
            </div>
            <DashboardHealthSquaresComponent data={this.state.data} identification={this.props.params.patient}/>
           
          </div>
          
          <div className='timeline-component-container'>
            <iframe src={'timeline/?cedula=' + this.props.params.patient} width='100%' height='100%' frameBorder='0'></iframe>
          </div>

        </div>
        
      </div>
    )
  }
}

/* Validate Props */
PatientDashboard.propTypes = {
  params: React.PropTypes.object
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardComponent.js